/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useRouteMatch, useLocation, Redirect } from 'react-router-dom'

import RefundNoteForm from '../components/RefundNoteForm'
import { loadRefund, createNote, clearNewNote } from '../actions/fundingfeeActions'
import { URLs } from '../utils/refundUtils'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const RefundNoteContainer = ({ fundingFee, isAffiliate, loadRefund, createNote, clearNewNote }) => {
  const {
    params: { noteId, refundId }
  } = useRouteMatch(`${URLs.FUNDING_FEE_REFUND_APP_PATH}/:refundId/note/:noteId`)
  const { state: locationState } = useLocation()
  const isNew = noteId === 'new'
  const note = fundingFee[refundId]?.notes?.find(note => note.id === parseInt(noteId))

  useEffect(() => {
    // If we were redirected from a newly created note, clear it out so another can be created
    if (locationState?.newNote) {
      clearNewNote()
    } else if (note == null) {
      loadRefund(refundId)
    }
  }, [loadRefund, clearNewNote, refundId, note, locationState])

  // If a new note was created, load it up
  if (isNew && fundingFee.newNote != null) {
    return (
      <Redirect
        to={{
          pathname: `${URLs.FUNDING_FEE_REFUND_APP_PATH}/${refundId}/note/${fundingFee.newNote}`,
          state: { newNote: true }
        }}
      />
    )
  }

  return (
    <div className='lgy-funding-fee-note'>
      {fundingFee.success && (
        <LgyAlertDialog type='success' heading='Success'>
          Successfully created new note.
        </LgyAlertDialog>
      )}
      {fundingFee.error && (
        <LgyAlertDialog type='error' heading='Error'>
          Error creating note.
        </LgyAlertDialog>
      )}
      <RefundNoteForm
        form={`refundNoteForm${noteId}`}
        onSubmit={createNote}
        initialValues={{ ...note, refundId }}
        enableReinitialize
        {...{ isNew, isAffiliate }}
      />
    </div>
  )
}

const mapStateToProps = state => ({ fundingFee: state.fundingFee, isAffiliate: state.currentUser?.isAffiliate })

export default connect(mapStateToProps, { loadRefund, createNote, clearNewNote })(RefundNoteContainer)
